import React, { useEffect, useState } from 'react';
import moment from 'moment';
import ValuesRow from './organisms/ValuesRow'
import ChartsRow from './organisms/ChartsRow'
import FilterCard from './organisms/FilterCard'
import TableCard from './organisms/TableCard'
import { isAuthenticated } from '../../store/action/auth';
import { convertStatus } from "./helper/status";
import numeral from 'numeral';
import {
    getOrders
} from '../../store/action/analytics';

const Analytics = () => {
    const { user, token } = isAuthenticated();
    const [ date, setDate ] = useState({
        startDate:moment().add(-30,'days').format("YYYY-MM-DD"),
        endDate:moment().format("YYYY-MM-DD"),
    })
    const [ data1, setData1 ] = useState({
        data:[],
        loading:true
    })
    const [ data2, setData2 ] = useState({
        data:[{
            date:moment().format("YYYY-MM-DD"),
            quantity:0
        }],
        loading:true
    })
    const [ data3, setData3 ] = useState({
        data:[],
        loading:true
    })
    const [ data4, setData4 ] = useState({
        data:[{
            title:"",
            value:0
        }],
        loading:true
    })
    const [ data5, setData5 ] = useState({
        data:[{
            title:"",
            value:0
        }],
        loading:true
    })
    const [ delays, setDelays ] = useState({
        delay:0,
        total:0,
        orderIds:[]
    })
    const [ selectedCouriers, setSelectedCouriers ] = useState([])
    const endpointsValue = [
        {name:'avg_quantity_per_day',text:'Avg. Quantity per Day',format:(v) => {return `${v}`}},
        {name:'avg_price_per_order',text:'Avg. Cost per Shipment',format:(v) => {return `Rp. ${numeral(v).format("0,0")}`}},
        {name:'avg_delivery_time_per_order',text:'Avg. Delivery Time',format:(v) => {return `${v} Jam`}},
        {name:'avg_item_weight_per_order',text:'Avg. Item Weight',format:(v) => {return `${v} Gram`}}
    ]

    useEffect(() => {
        _fetchData();
    }, []);
        
    const _fetchData = async (sd,ed) => {
        const startDate = sd || date.startDate
        const endDate = ed || date.endDate

        setData1({...data1,loading:true})
        setData2({...data2,loading:true})
        setData3({...data3,loading:true})
        setData4({...data4,loading:true})
        setData5({...data5,loading:true})

        getOrders(`start_date=${startDate}&end_date=${endDate}&group_by=status&status=confirmed,dropping_off,delivered,picked,picking_up,cancelled&couriers=${selectedCouriers}`,token)
        .then(res => {
            if (!res.success){
                return alert(res.error)
            }
            const {orders} = res;
            const formattedOrders = orders.reduce((r,i) => {
                r.push({
                    title:convertStatus(i.status),
                    value:i.quantity
                });
                return r;
            },[])
            setData1({
                data:formattedOrders,
                loading:false
            })
        })
        .catch(e => {
            console.log(e.message)
        })

        getOrders(`start_date=${startDate}&end_date=${endDate}&group_by=dailySLA&couriers=${selectedCouriers}`,token)
        .then(res => {
            if (!res.success){
                return alert(res.error)
            }
            let delays = 0;
            let total = 0;
            const formattedOrders = res.orders.reduce((r,i) => {
                if (i.over_time > 0 ) {
                    delays += i.over_time
                }
                total += i.quantity ? parseInt(i.quantity) : 0
                r.push({
                    date:i.date,
                    ["On Time"]:i.on_time,
                    ["Delay"]:i.over_time,
                    ["Before Time"]:i.before_time,
                    ["Total"]:i.quantity,
                    ["% Delay"]:`${Math.round(i.over_time/i.quantity*100)}%`,
                    quantity:i.quantity,
                    price:i.price
                })
                
                return r;
            },[])
            setDelays({
                ...delays,
                delays:delays,
                total:total
            })
            setData2({
                data:formattedOrders,
                loading:false
            })
        })
        .catch(e => {
            console.log(e.message)
        })

        let resData3 = [];
        for (let i = 0; i<endpointsValue.length;i++) {
            const value = endpointsValue[i]
            await getOrders(`start_date=${startDate}&end_date=${endDate}&type=number&value=${value.name}&couriers=${selectedCouriers}`,token)
            .then(res => {
                if (!res.success){return console.log(res.error)}
                resData3.push({
                    title:value.text,
                    value:res.value,
                    format:value.format
                })
            })
            .catch(e => {console.log(e.message)})
        }

        setData3({
            data:resData3,
            loading:false
        })

        getOrders(`start_date=${startDate}&end_date=${endDate}&group_by=couriers&limit=5&sort=descending&couriers=${selectedCouriers}`,token)
        .then(res => {
            if (!res.success){
                return alert(res.error)
            }
           
            const formattedOrders = res.orders.reduce((r,i) => {
                r.push({
                    title:i.courier_name,
                    value:i.quantity
                })
                return r;
            },[])
            setData4({
                data:formattedOrders,
                loading:false
            })
        })
        .catch(e => {
            console.log(e.message)
        })

        getOrders(`start_date=${startDate}&end_date=${endDate}&group_by=province&limit=5&sort=descending&couriers=${selectedCouriers}`,token)
        .then(res => {
            if (!res.success){
                return alert(res.error)
            }
           
            const formattedOrders = res.orders.reduce((r,i) => {
                r.push({
                    title:i.city,
                    value:i.quantity
                })
                return r;
            },[])
            setData5({
                data:formattedOrders,
                loading:false
            })
        })
        .catch(e => {
            console.log(e.message)
        })
    }

    const onChangeDate = async (type, value)=>{
        let sd,ed;
        if (type === 'from') {
            sd = moment(value).format("YYYY-MM-DD")
            setDate({...date,startDate:sd})
            _fetchData(sd);
        } else {
            ed = moment(value).format("YYYY-MM-DD")
            setDate({...date,endDate:ed})
            _fetchData(null,ed);
        }
        
    }

    return (
        <div>
            <FilterCard
                className="mb-4"
                onSetFromDate={e => onChangeDate('from',e)}
                onSetToDate={e => onChangeDate('to',e)}
                selectedCouriers={arr => setSelectedCouriers(arr)}
                onClickFilter={() => _fetchData()}
            />
            <ValuesRow
                className="mb-4"
                title={"Progres Pengiriman"}
                data={data1.data}
                loading={data1.loading}
            />
            <ValuesRow
                className="mb-4"
                title={"Nilai Pengiriman"}
                data={data3.data}
                loading={data3.loading}
            />
            <ChartsRow
                className="mb-4"
                title={"Performa Pengiriman"}
                type={"orderPerformance"}
                xAxisType={"date"}
                data={data2.data}
                loading={data2.loading}
                delayShipments={delays.delays}
                totalShipments={delays.total}
            />
            <div className="row mb-4">
                <div className="col">
                    <TableCard
                        title={"Top Kurir"}
                        headers={["Kurir","Jumlah Pengiriman"]}
                        loading={data4.loading}
                        data={data4.data}
                    />
                </div>
                <div className="col">
                    <TableCard
                        title={"Top Lokasi Pengiriman"}
                        headers={["Kota","Jumlah Pengiriman"]}
                        loading={data5.loading}
                        data={data5.data}
                    />
                </div>
            </div>
        </div>
    );
};

export default Analytics;
